import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import checkedIcon from '../../../assets/images/icon/checkbox-checked-darkgreen.svg'

const CheckboxWrapper = styled.div`
  display: inline-flex;
  align-items: center;
`;

const CheckboxBtn = styled.button`
  display: inline-block;
  padding: 0;
  min-width: 18px;
  width: 18px;
  height: 18px;
  border: 1px solid ${props => props.theme.colors.darkgrey};
  border-radius: 2px;
  background-color: ${props => props.theme.colors.cremewhite};
  
  &:hover {
    border-color: ${props => props.theme.colors.cremewhite};
    cursor: pointer;
    background-color: ${props => props.theme.colors.lightgreen20};
  }
  
  ${props => props.active && css`
    border: 1px solid ${props => props.theme.colors.darkgreen};
    background: url(${checkedIcon}) no-repeat 50%;
  `}
`;

const CheckboxText = styled.span`
  line-height: 40px;
  font-family: Montserrat;
  font-size: 14px;
  user-select: none;   
  &:hover {cursor: pointer;}
`;

const Checkbox = ({ active, children, customText, checkboxStyle, textStyle, clicked, buttonProps }) => (
  <CheckboxWrapper onClick={clicked}>
    <CheckboxBtn active={active} style={checkboxStyle} type="button" {...buttonProps} />
    <CheckboxText style={textStyle}>{ children }</CheckboxText>
    { customText }
  </CheckboxWrapper>
);

Checkbox.propTypes = {
  active: PropTypes.bool,
  children: PropTypes.string,
  customText: PropTypes.element,
  checkboxStyle: PropTypes.object,
  buttonProps: PropTypes.object,
  textStyle: PropTypes.object,
  clicked: PropTypes.func
};

Checkbox.defaultProps = {
  buttonProps: {}
};

export default Checkbox;
